import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';
import { AmbientVolumeType } from '../../types';

interface Props {
  trigger: Trigger;
}

export function AmbientTradeTriggerFullDetails({ trigger }: Props) {
  const volumeType = trigger.context?.volumeType as AmbientVolumeType | undefined;

  const volumeTypeDisplay = useMemo(() => {
    if (!volumeType) return '-';

    const volumeTypeLabels: Record<AmbientVolumeType, string> = {
      [AmbientVolumeType.MakerVolume]: 'Maker Volume',
      [AmbientVolumeType.TakerVolume]: 'Taker Volume',
      [AmbientVolumeType.AllVolume]: 'All Volume',
    };

    const label = volumeTypeLabels[volumeType] || volumeType;
    return <Badge size="sm">{label}</Badge>;
  }, [volumeType]);

  const executedWhenDisplay = useMemo(() => {
    return (
      <Text as="span" variant="body-sm" color="muted" className="tw:inline tw:flex-wrap">
        User performs trades on{' '}
        <Badge size="sm" className="tw:align-middle">
          Ambient
        </Badge>{' '}
        with volume type: {volumeTypeDisplay}
      </Text>
    );
  }, [volumeTypeDisplay]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Volume Type" value={volumeTypeDisplay} />
      <KeyValueRow label="Executed when" value={executedWhenDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
